import { Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { NextSeo } from "next-seo";
import { GetServerSideProps } from "next";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { GET_AUTHOR, GET_FOOTER_DATA, GET_HEADER_DATA, GET_HOMEPAGE_DATA, GET_LATEST_AUTHOR_POSTS } from "@/graphql/queries";
import { breadcrumbInitial } from "@/data/breadcrumbInitial";
import { handleError } from "@/helpers/handleError";
import { BreadcrumbType } from "@/Types/types";

import HeaderMenu from "@/components/HeaderMenu";
import Footer from "@/components/Footer";
import AuthorCardHorizontal from "@/components/AuthorCardHorizontal";
import Breadcrumbs from "@/components/Breadcrumbs";
import RecentPosts from "@/components/MainPage/RecentPosts";
import TrendingCarousel from "@/components/MainPage/TrendingCarousel";

export default function PostPage(props: any) {
  const [counter, setCounter] = useState<number>();
  const [isMobile, setIsMobile] = useState<Boolean>();

  useEffect(() => {
    setIsMobile(window.innerWidth <= 991 ? true : false);
  })

  useEffect(() => {
    setCounter(props.authorPosts.meta.pagination.total);
  }, [props]);

  return (
    <Box bgColor="#FFFCF6">
      <HeaderMenu cookies={props.cookies.data} menu={props.header[0].items} submenu={props.navbar.data?.attributes.submenu_header} />
      <NextSeo
        title={props.author.data[0].attributes.metaTitle}
        description={props.author.data[0].attributes.metaDescription}
        canonical={props.author.data[0].attributes.canonicalUrl}
      />
      <Box
        maxWidth="1216px"
        margin="0 auto"
        width={{ base: "90%", lg: "100%" }}
        as="header"
        pt={{ base: "0px", lg: "80px" }}
      >
        <Box mb="32px" >
          <Breadcrumbs data={props.breadcrumbs} />
        </Box>
        <AuthorCardHorizontal author={props.author.data[0]} publicationNumber={counter} isAuthorPage />
      </Box>
      <RecentPosts data={props.authorPosts.data} />
      {!isMobile && Boolean(props.trending.data.length) && (
        <TrendingCarousel
          data={props.trending.data}
        />
      )}
      
      <Footer menu={props.footer[0].items} />
    </Box>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  try {
    context.res.setHeader(
      "Cache-Control",
      "public, s-maxage=10, stale-while-revalidate=59"
    );

    const client = new ApolloClient({
      uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
      cache: new InMemoryCache(),
    });

    const { data: headerData } = await client.query({
      query: GET_HEADER_DATA,
    });

    const { data: footerData } = await client.query({
      query: GET_FOOTER_DATA,
    });

    const { data: authorData } = await client.query({
      query: GET_AUTHOR,
      variables: { slugUrl: context.params?.slug },
    });

    if (!authorData.author.data.length) {
      return {
        notFound: true,
      };
    }

    const { data: authorPosts } = await client.query({
      query: GET_LATEST_AUTHOR_POSTS,
      variables: {
        author: authorData.author.data[0].attributes.url,
        page: (context.query?.page && +context.query?.page) || 1,
      },
    });

    const breadcrumbs: BreadcrumbType[] = JSON.parse(JSON.stringify(breadcrumbInitial));

    breadcrumbs.push({
      href: `/`,
      label: `Perfil`,
    });
    breadcrumbs.push({
      href: `/blog/perfil/${authorData.author.data[0].attributes.url}`,
      label: `${authorData.author.data[0].attributes.name}`,
    });

    const { data: homepageData } = await client.query({
      query: GET_HOMEPAGE_DATA,
    });

    return {
      props: {
        ...authorData,
        ...authorPosts,
        ...headerData,
        ...footerData,
        ...homepageData,
        breadcrumbs,
      },
    };
  } catch (error) {
    handleError(error, "Perfil Slug getServerSideProps");
    return {
      notFound: true,
    };
  }
};
